<div>
    <button (click)="zoomIn()">🔍 Zoom +</button>
    <button (click)="zoomOut()">🔍 Zoom -</button>
    <button (click)="prevPage()">⬅️ Anterior</button>
    <button (click)="nextPage()">➡️ Siguiente</button>
    <button (click)="downloadPdf()">⬇️ Descargar</button>
  </div>
<pdf-viewer
  *ngIf="bigFile"
  [src]="pdfSrc!"
  [render-text]="false"
  [original-size]="false"
  [show-all]="false"
  [page]="page"
  [zoom]="zoom"
  style="display:block">
</pdf-viewer>
<pdf-viewer
  *ngIf="!bigFile"
  [src]="pdfSrc!"
  [render-text]="false"
  [original-size]="false"
  [show-all]="false"
  [page]="page"
  [zoom]="zoom"
  style="display:block">
</pdf-viewer>